module.exports = require('./helpers/bundle-url').getBundleURL('5KjyH') + "logo.c51670a8.svg";